const getOrdinalSuffix = (day) => {
  if (day >= 11 && day <= 13) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const DateFormatter = (dateString) => {
  const date = new Date(dateString);

  const month = date.toLocaleDateString("en-US", { month: "long" });

  const day = date.getDate();
  const ordinalSuffix = getOrdinalSuffix(day);

  const year = date.getFullYear();

  return `${month} ${day}${ordinalSuffix}, ${year}`;
};
